<template>
  <p>
    Return to
    <BaseLinkOpenNew url="https://dmv.ri.gov/online-services" name="RI DMV Online Services" />
  </p>
</template>

<script>
import BaseLinkOpenNew from "./ui/BaseLinkOpenNew"

export default {
  name: 'RiDmvHome',
  components: {
    BaseLinkOpenNew,
  }
}
</script>
